import { declareComponents } from '/vodalys/vvuejs'

import components from './component/**/*.vue'
declareComponents('components', components)